import type { DeckLibraryStore, ManagedDeckRecord } from "../schemas"
import { DeckLibraryStoreSchema } from "../schemas"

export const DECK_LIBRARY_STORAGE_KEY = "craft-force.deck-library"
export const DECK_LIBRARY_STORAGE_VERSION = 1
export const DeckLibraryStateSchema = DeckLibraryStoreSchema
export const EMPTY_DECK_LIBRARY: DeckLibraryStore = []

export const SEED_DECK_LIBRARY: DeckLibraryStore = [
  {
    deck: {
      deckId: "deck_red_starter",
      name: "Red Starter",
      heroId: "hero_ironclad",
      mercEntries: [
        { cardId: "card_red_brawler", count: 3 },
        { cardId: "card_yellow_marshal", count: 3 },
      ],
    },
    updatedAt: "2026-03-20T14:00:00.000Z",
  },
]

export function createDeckId(name: string): string {
  const slug = name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/gu, "_")
    .replace(/^_+|_+$/gu, "")
  return `deck_${slug || "custom"}_${Date.now().toString(36)}`
}

export function buildDuplicatedDeckRecord(
  source: ManagedDeckRecord,
  existingDecks: DeckLibraryStore,
): ManagedDeckRecord {
  const existingNames = existingDecks.map((r) => r.deck.name)
  const nextName = getNextDuplicateName(source.deck.name, existingNames)
  return {
    deck: {
      ...source.deck,
      deckId: createDeckId(nextName),
      name: nextName,
    },
    ownerUserId: source.ownerUserId,
    remoteSyncFailedAt: undefined,
    remoteSyncedAt: undefined,
    updatedAt: new Date().toISOString(),
  }
}

function getNextDuplicateName(
  sourceName: string,
  existingNames: readonly string[],
): string {
  const lower = new Set(existingNames.map((n) => n.toLowerCase()))
  if (!lower.has(sourceName.toLowerCase())) return sourceName
  let i = 2
  while (lower.has(`${sourceName} ${i}`.toLowerCase())) i++
  return `${sourceName} ${i}`
}
